<dcp-order-item
  (removeAction)="triggerRemoval()"
  (editAction)="openEditModal()"
  [showEditAction]="showEditAction"
  [showRemoveAction]="showRemoveAction"
  [showPrice]="showPrice"
  [isInvalid]="isInvalid"
  [orderEntry]="cartEntry"
  [collapsable]="collapsable"
  [collapsed]="collapsed"
  [componentTexts]="componentTexts"
></dcp-order-item>
<ng-template #modalContent>
  <dcp-edit-cart-page
    (addedToCart)="this.modalService.closeModal(modalId)"
    (triggerClose)="this.modalService.closeModal(modalId)"
    [cartEntry]="cartEntry"
    [isModalOpened]="true"
    [forceModal]="true"
  ></dcp-edit-cart-page>
  <dcp-checkout-support-widget
    [componentData]="supportWidgetComponentData"
    class="support-widget-edit-cart"
  ></dcp-checkout-support-widget>
</ng-template>
